/* Stadesks — storefront checkout hand-off.
 *
 * Every checkout entry point in the theme is redirected to the house checkout on
 * checkout.stadesks.com, which re-prices the cart server-side from its own catalogue
 * (variant id -> EUR) and pays via iDEAL / Bancontact on the garagedo Airwallex bridge.
 *
 * Shopify's native checkout is never reached: the cart page button, the cart drawer button,
 * the cart-notification button and the dynamic "Buy it now" buttons are all either hijacked
 * or hidden. The hand-off carries no secret — the checkout re-prices everything from its own
 * catalogue, so a tampered cart payload cannot change what the buyer is charged.
 */
(function () {
  'use strict';

  var PAY = 'https://checkout.stadesks.com/pay/';
  var CUR = 'EUR', SYM = '€';

  function b64url(obj) {
    var json = JSON.stringify(obj);
    // btoa() is latin1-only and Dutch product titles carry en-dashes and accents. Round-trip
    // through UTF-8 exactly the way the checkout decodes it: decodeURIComponent(escape(atob(x))).
    var b64 = btoa(unescape(encodeURIComponent(json)));
    return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  function absolute(src) {
    if (!src) return '';
    if (src.indexOf('//') === 0) return 'https:' + src;
    return src;
  }

  var going = false;

  function handoff() {
    if (going) return;
    going = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) { going = false; window.location.href = '/cart'; return; }
        var payload = {
          cur: CUR,
          sym: SYM,
          // Shopify money fields are minor units throughout.
          total: cart.total_price / 100,
          items: cart.items.map(function (i) {
            return {
              id: String(i.variant_id),
              q: i.quantity,
              title: i.product_title + (i.variant_title && i.variant_title !== 'Default Title' ? ' — ' + i.variant_title : ''),
              line: i.final_line_price / 100,
              img: absolute(i.image || '')
            };
          })
        };
        window.location.href = PAY + '?cart=' + b64url(payload);
      })
      .catch(function () { going = false; window.location.href = '/cart'; });
  }

  // Any element that would otherwise submit the buyer into Shopify's checkout. The last few
  // entries are this theme's own (custom "standeks" theme, not Dawn) — verified against the
  // live templates rather than assumed, because a missed selector silently leaks a buyer to
  // Shopify's checkout, where the order is taken but the rail never sees it.
  var SEL = [
    'button[name="checkout"]', 'input[name="checkout"]', 'a[href="/checkout"]',
    'a[href^="/checkout?"]', '#checkout', '#CartDrawer-Checkout', '.cart__checkout-button',
    '[data-cart-checkout]', '.cart-checkout', '.drawer-checkout', '.js-checkout',
    '[data-std-checkout]'
  ].join(',');

  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest(SEL) : null;
    if (!el) return;
    e.preventDefault();
    e.stopPropagation();
    handoff();
  }, true); // capture: beat the theme's own submit handlers

  // The cart page/drawer posts a <form action="/cart"> whose submitter is name="checkout".
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute) return;
    var action = f.getAttribute('action') || '';
    if (action.indexOf('/cart') !== 0 && action.indexOf('/checkout') !== 0) return;
    var sub = e.submitter;
    if (action.indexOf('/checkout') === 0 || (sub && sub.name === 'checkout')) {
      e.preventDefault();
      e.stopPropagation();
      handoff();
    }
  }, true);

  // Accelerated/dynamic checkout buttons (Shop Pay, PayPal, Google Pay) navigate straight to
  // Shopify's checkout and cannot be intercepted reliably — remove them from the page.
  var css = document.createElement('style');
  css.textContent = '.shopify-payment-button,.shopify-payment-button__button,' +
    '.cart__dynamic-checkout-buttons,#dynamic-checkout-cart,' +
    '[data-shopify="dynamic-checkout-cart"],[data-shopify="payment-button"]{display:none !important}';
  document.head.appendChild(css);
})();
